const FIXED_GROUP_TEMPLATES = [
    {
        id: "system-group-subgroup-example",
        name: "Grupo e Subgrupo",
        isSystem: true,
        json: JSON.stringify([
            {
                id: "",
                name: "Grupo Exemplo 1",
                order: 1,
                collapsed: false,
                subgroups: [
                    {
                        id: "",
                        name: "Subgrupo Exemplo 1",
                        order: 1,
                        products: [],
                    },
                    {
                        id: "",
                        name: "Subgrupo Exemplo 2",
                        order: 2,
                        products: [],
                    },
                ],
            },
            {
                id: "",
                name: "Grupo Exemplo 2",
                order: 2,
                collapsed: false,
                subgroups: [
                    {
                        id: "",
                        name: "Subgrupo Exemplo 1",
                        order: 1,
                        products: [],
                    },
                    {
                        id: "",
                        name: "Subgrupo Exemplo 2",
                        order: 2,
                        products: [],
                    },
                ],
            },
        ]),
    },
    {
        id: "system-hash-group-template",
        name: "Subgrupo",
        isSystem: true,
        json: JSON.stringify([
            {
                id: "",
                name: "#",
                order: 1,
                collapsed: false,
                subgroups: [
                    {
                        id: "",
                        name: "Subgrupo Exemplo 1",
                        order: 1,
                        products: [],
                    },
                    {
                        id: "",
                        name: "Subgrupo Exemplo 2",
                        order: 2,
                        products: [],
                    },
                ],
            },
        ]),
    },
];

export default {
    namespaced: true,
    state: {
        groupTemplates: JSON.parse(JSON.stringify(FIXED_GROUP_TEMPLATES)),
        withoutGroupStructure: false,
    },
    mutations: {
        setGroupTemplates: (state, templates) => {
            const apiTemplates = Array.isArray(templates) ? templates : [];
            const apiById = new Set(
                apiTemplates
                    .map((template) => template && template.id)
                    .filter(Boolean)
            );
            const fixedTemplates = FIXED_GROUP_TEMPLATES.filter(
                (template) => !apiById.has(template.id)
            );
            state.groupTemplates = [
                ...JSON.parse(JSON.stringify(fixedTemplates)),
                ...apiTemplates,
            ];
        },
        setWithoutGroupStructure: (state, withoutFilter) => {
            state.withoutGroupStructure = Boolean(withoutFilter);
        },
    },
}